import React from 'react';
import { connect } from 'react-redux';
import async from 'async';
import ReactTable from 'react-table';
import Translate from 'translate';
import moment from 'moment';
import classnames from 'classnames';

import SocialNetworkService from 'services/SocialNetwork';
import NetworkService from 'services/NetworkService';
import ChatConfigurationService from 'services/ChatConfigurationService';
import { toggleLoading, toggleAlertError } from 'stores/actions';

class Status extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      facebook: [],
      twitter: [],
      sms: [],
      email: [],
      chatConfig: {}
    };

    this.getData = this.getData.bind( this );
    this.toggleChatStatus = this.toggleChatStatus.bind( this );
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      facebook: this.getFacebookStatus.bind( this ),
      twitter: this.getTwitterStatus.bind( this ),
      email: this.getEmailStatus.bind( this ),
      chatConfig: this.getChatConfig.bind( this ),
      sms: this.getSmsStatus.bind( this ),
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( !error || error === 'Type not found.' ) this.setState( results )
    } )
  }

  reloadSocialNetwork = ( type, action ) => {
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    NetworkService.sendNetworkAction( type, action )
      .then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) {
          return toggleAlertError( response.errors )
        } else {
          toggleAlertError( 'The operation completed successfully' );

          if( type === 'facebook' ) {
            this.getFacebookStatus()
          }
          if( type === 'twitter' ) {
            this.getTwitterStatus()
          }
          if( type === 'email' ) {
            this.getEmailStatus()
          }
          if( type === 'phone' ) {
            this.getSmsStatus()
          }
        }
      } )
  };

  getFacebookStatus( cb ) {
    const { toggleLoading } = this.props;

    if( !cb ) toggleLoading( true );
    SocialNetworkService.getStatus( 'facebook' )
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );
        toggleLoading( false );
        if( !response.errors ) this.setState( { facebook: response.data } )
      } )
  }

  getTwitterStatus( cb ) {
    const { toggleLoading } = this.props;

    if( !cb ) toggleLoading( true );
    SocialNetworkService.getStatus( 'twitter' )
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );
        toggleLoading( false );
        if( !response.errors ) this.setState( { twitter: response.data } )
      } )
  }

  getEmailStatus( cb ) {
    const { toggleLoading } = this.props;

    if( !cb ) toggleLoading( true );
    SocialNetworkService.getStatus( 'email' )
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );
        toggleLoading( false );
        if( !response.errors ) this.setState( { email: response.data } )
      } )
  }

  getSmsStatus( cb ) {
    const { toggleLoading } = this.props;

    if( !cb ) toggleLoading( true );
    SocialNetworkService.getStatus( 'phone' )
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );
        toggleLoading( false );
        if( !response.errors ) this.setState( { sms: response.data } )
      } )
  }

  getChatConfig( cb ) {
    const { toggleLoading } = this.props;

    if( !cb ) toggleLoading( true );
    ChatConfigurationService.getChatConfig()
      .then( ( response ) => {
        if( cb ) return cb( response.errors, response.data );
        toggleLoading( false );
        if( !response.errors ) this.setState( { chatConfig: response.data } )
      } )
  }

  toggleChatStatus() {
    const { toggleAlertError, toggleLoading } = this.props;
    const { chatConfig } = this.state;

    toggleLoading( true );

    ChatConfigurationService.updateChatConfig( chatConfig.id, { active: !chatConfig.active } )
      .then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) return toggleAlertError( response.errors );
        toggleAlertError( 'Information updated' );
        console.log( response.data )
        this.setState( { chatConfig: { ...chatConfig, active: !chatConfig.active } } )
      } )
  }

  render() {
    const { chatConfig } = this.state;

    return (
      <div className="box box-default">
        <div className="box-header">
          <span className="text-capitalize"><Translate id="networksStatus"/></span>
        </div>
        <div className="box-body">
          <div className="mb-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <p className="m-0">Chat</p>
              <div>
                <button className="btn btn-info ml-4" onClick={this.toggleChatStatus}>
                  <Translate id={chatConfig.active ? 'deactivate' : 'activate'}/>
                </button>
              </div>
            </div>

            <ReactTable className="app-table -highlight app-table-white mb-5"
                        data={[chatConfig]}
                        pageSize={1}
                        showPagination={false}
                        resizable={false}
                        sortable={false}
                        columns={[
                          {
                            Header: <Translate id="monday"/>, accessor: 'mondayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.mondayTo ? '-' : `${props.value || ''} - ${chatConfig.mondayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="tuesday"/>, accessor: 'tuesdayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.tuesdayTo ? '-' : `${props.value || ''} - ${chatConfig.tuesdayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="wednesday"/>, accessor: 'wednesdayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.wednesdayTo ? '-' : `${props.value || ''} - ${chatConfig.wednesdayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="thursday"/>, accessor: 'thursdayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.thursdayTo ? '-' : `${props.value || ''} - ${chatConfig.thursdayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="friday"/>, accessor: 'fridayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.fridayTo ? '-' : `${props.value || ''} - ${chatConfig.fridayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="saturday"/>, accessor: 'saturdayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.saturdayTo ? '-' : `${props.value || ''} - ${chatConfig.saturdayTo || ''}`}</span>
                          },
                          {
                            Header: <Translate id="sunday"/>, accessor: 'sundayFrom',
                            Cell: props =>
                              <span>{!props.value && !props.original.sundayTo ? '-' : `${props.value || ''} - ${chatConfig.sundayTo || ''}`}</span>
                          },
                        ]}
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="m-0">Facebook</p>
            <div>
              <button className="btn btn-info ml-4" onClick={() => this.reloadSocialNetwork( 'facebook', 'run' )}>
                <Translate id="start"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'facebook', 'stop' )}>
                <Translate id="stop"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'facebook', 'clean' )}>
                <Translate id="clean"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.getFacebookStatus()}>
                <Translate id="reload"/>
              </button>
            </div>
          </div>
          <ReactTable className="app-table -highlight -striped app-table-white"
                      data={this.state.facebook}
                      pageSize={this.state.facebook.length}
                      showPagination={false}
                      resizable={false}
                      columns={[
                        { Header: <Translate id="id"/>, accessor: 'id' },
                        {
                          Header: <Translate id="state"/>, accessor: 'state',
                          Cell: props => <span className={classnames( {
                            'text-warning': props.value === 'pending',
                            'text-success': props.value === 'running'
                          } )}>{props.value ? props.value.toUpperCase() : ''}</span>
                        },
                        {
                          Header: <Translate id="createdAt"/>, accessor: 'created',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                        {
                          Header: <Translate id="executeAfter"/>, accessor: 'executeAfter',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                      ]}
          />

          <div className="d-flex justify-content-between align-items-center mb-2 mt-5">
            <p className="m-0">Twitter</p>
            <div>
              <button className="btn btn-info ml-4" onClick={() => this.reloadSocialNetwork( 'twitter', 'run' )}>
                <Translate id="start"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'twitter', 'stop' )}>
                <Translate id="stop"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'twitter', 'clean' )}>
                <Translate id="clean"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.getTwitterStatus()}>
                <Translate id="reload"/>
              </button>
            </div>
          </div>
          <ReactTable className="app-table -highlight -striped app-table-white"
                      data={this.state.twitter}
                      pageSize={this.state.twitter.length}
                      showPagination={false}
                      resizable={false}
                      columns={[
                        { Header: <Translate id="id"/>, accessor: 'id' },
                        {
                          Header: <Translate id="state"/>, accessor: 'state',
                          Cell: props => <span className={classnames( {
                            'text-warning': props.value === 'pending',
                            'text-success': props.value === 'running'
                          } )}>{props.value ? props.value.toUpperCase() : ''}</span>
                        },
                        {
                          Header: <Translate id="createdAt"/>, accessor: 'created',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                        {
                          Header: <Translate id="executeAfter"/>, accessor: 'executeAfter',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                      ]}
          />

          <div className="d-flex justify-content-between align-items-center mb-2 mt-5">
            <p className="m-0">Email</p>
            <div>
              <button className="btn btn-info ml-4" onClick={() => this.reloadSocialNetwork( 'email', 'run' )}>
                <Translate id="start"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'email', 'stop' )}>
                <Translate id="stop"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'email', 'clean' )}>
                <Translate id="clean"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.getEmailStatus()}>
                <Translate id="reload"/>
              </button>
            </div>
          </div>
          <ReactTable className="app-table -highlight -striped app-table-white"
                      data={this.state.email}
                      pageSize={this.state.email.length}
                      showPagination={false}
                      resizable={false}
                      columns={[
                        { Header: <Translate id="id"/>, accessor: 'id' },
                        {
                          Header: <Translate id="state"/>, accessor: 'state',
                          Cell: props => <span className={classnames( {
                            'text-warning': props.value === 'pending',
                            'text-success': props.value === 'running'
                          } )}>{props.value ? props.value.toUpperCase() : ''}</span>
                        },
                        {
                          Header: <Translate id="createdAt"/>, accessor: 'created',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                        {
                          Header: <Translate id="executeAfter"/>, accessor: 'executeAfter',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                      ]}
          />

          <div className="d-flex justify-content-between align-items-center mb-2 mt-5">
            <p className="m-0">SMS</p>
            <div>
              <button className="btn btn-info ml-4" onClick={() => this.reloadSocialNetwork( 'phone', 'run' )}>
                <Translate id="start"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'phone', 'stop' )}>
                <Translate id="stop"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.reloadSocialNetwork( 'phone', 'clean' )}>
                <Translate id="clean"/>
              </button>
              <button className="btn btn-info ml-2" onClick={() => this.getSmsStatus()}>
                <Translate id="reload"/>
              </button>
            </div>
          </div>
          <ReactTable className="app-table -highlight -striped app-table-white"
                      data={this.state.sms}
                      pageSize={ this.state.sms ? this.state.sms.length : 0}
                      showPagination={false}
                      resizable={false}
                      columns={[
                        { Header: <Translate id="id"/>, accessor: 'id' },
                        {
                          Header: <Translate id="state"/>, accessor: 'state',
                          Cell: props => <span className={classnames( {
                            'text-warning': props.value === 'pending',
                            'text-success': props.value === 'running'
                          } )}>{props.value ? props.value.toUpperCase() : ''}</span>
                        },
                        {
                          Header: <Translate id="createdAt"/>, accessor: 'created',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                        {
                          Header: <Translate id="executeAfter"/>, accessor: 'executeAfter',
                          Cell: props => props.value ? moment( props.value ).format( 'DD/MM/YYYY hh:mm A' ) : ''
                        },
                      ]}
          />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( msg ) => {
    dispatch( toggleAlertError( msg ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( Status );



// WEBPACK FOOTER //
// ./routes/app/routes/management/status/index.js